export default __webpack_public_path__ + "static/media/33.cc955c1a.png";